module.exports = __webpack_public_path__ + "static/media/younglady.7081b2ac.jpg";